<template>
  <div class="VacationArchiveDetails">
    <v-dialog v-model="visible">
      <box :title="$t('vacationDetails')">
        <v-row class="pa-2">
          <v-col cols="6"
            >{{ $t("PageNo") }}:<span class="text-value">{{
              details.PageNo
            }}</span></v-col
          >
          <v-col cols="6"
            >{{ $t("RequestedPersonName") }}:<span class="text-value">{{
              details.PersonName
            }}</span></v-col
          >
          <v-col cols="6"
            >{{ $t("requestType") }}:<span class="text-value">{{
              vacation.Name
            }}</span></v-col
          >
          <v-col cols="6"
            >{{ $t("LastChangeDate") }}:<span class="text-value">{{
              details.LastChangeDate
            }}</span></v-col
          >
          <v-col cols="6"
            >{{ $t("status") }}:<span
              class="text-value"
              v-text="
                vacation.StatusType +
                '-' +
                (details.IsTransfer ? 'انتقال داده شده' : 'انتقال داده نشده')
              "
            ></span
          ></v-col>
          <v-col cols="6"
            >{{ $t("ApprovedPerson") }}:<span
              class="text-value"
              v-text="ApprovedPerson"
            ></span
          ></v-col>
          <v-col cols="6">
            {{ $t("description") }}:

            <span class="text-value">
              {{ details.PersonName }}:{{ details.UserDescription }} <br />
              <span>تائید / رد کننده: {{ details.RejectCommand }}</span></span
            ></v-col
          >
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small v-if="visibleEdit" @click="edit">{{ $t("edit") }}</v-btn>
          <v-btn small v-if="visibleDelete" @click="deleteItem">{{ $t("delete") }}</v-btn>
        </v-card-actions>

        <archive-detals-flow
        v-if="ShowVacationFlow"
          :pageNo="details.PageNo"
          :pageType="1"
          :year="vacation.Year"
        />
        <div v-else class="text-center py-3">
          <span> روند جریان برگه های منتقل شده قابل مشاهده نمی باشد </span>
        </div>
      </box>
    </v-dialog>
  </div>
</template>

<script>
import ArchiveDetalsFlow from "./ArchiveDetalsFlow.vue";
import ResultType from "../../model/ResultType";
import RequestState from "../../model/RequestState";

export default {
  components: { ArchiveDetalsFlow },
  props: {},
  data() {
    return {
      visible: false,
      vacation: "",
      details: "",
      visibleEdit: false,
      visibleDelete: false,
      ApprovedPerson: "",
      externalFlow:false,
      ShowVacationFlow: true,
    };
  },
  methods: {
    show(vacation, details) {
      this.visible = true;
      this.vacation = vacation;
      this.details = details;
      this.checkActionsVisiblity();
      this.getApprovedPerson();
      // //debugger;
    },
    hide() {
      this.visible = false;
    },
    getApprovedPerson() {
      // //debugger;
      if (this.details.ApprovedPerson.trim() == "-1") {
        this.ApprovedPerson = this.$t("webkartManager");
      } else if (this.details.ApprovedPerson.trim() == "000") {
        this.ApprovedPerson = this.$t("winkartManager");
      } else {
        let params = new URLSearchParams();
        params.append('perno', this.details.ApprovedPerson.trim());
        this.$store.dispatch("GetPersonFullName", {params}).then((result) => {
          if (result.type === ResultType.success) {
            this.ApprovedPerson = result.data;
          }
        });
      }
      //debugger;
      if(this.details.IsTransferransfer != true && this.details.DB == 1){
        // this.externalFlow=false;
        this.ShowVacationFlow=true;
      }
      else{
        // this.externalFlow=true;
        this.ShowVacationFlow=false;

      }
    },
    checkActionsVisiblity() {
      // //debugger;
      ////console.log(String.fromCharCode(1740));
      ////console.log(String.fromCharCode(1610));
      this.visibleEdit = false;
      this.visibleDelete = false;

      switch (this.vacation.Status) {
        case 0: //darkhost avaliyeh
        case 1: //bargasht khordeh
        case 2: //ersal mojadad
        case 4: //rad shodeh
          //btnPrint.Visible = false;
          this.visibleEdit = true;

          if (this.vacation.Status == 1) {
            //emkan hazfe darkhoste rad shodeh
            this.visibleEdit = false;
            this.visibleDelete =
              this.$store.state.personel.personelDetail.Permission[15].toString() ==
              "1";
          } else {
            this.visibleDelete = true;
          }
      }
    },
    edit() {
      //console.log(this.vacation);
      this.visible = false;
      let details = {
        PageNo: this.vacation.Pageno.toString().trim(),
        Year: this.vacation.Year,
        DBKind: this.vacation.DBKind,
        selectedPerno:this.$store.auth?.auth?.username,
        from:'request-leave-archive'
      };
      this.details['Year'] = this.vacation.Year;
      this.$router.push({
        name: "request-leave",
        params: { vacationDetails: details },
      });
    },
    deleteItem() {
      var params = [
        {
          PageNo: this.details.PageNo.trim(),
          Year: this.vacation.Year,
          AdminPerno: this.details.PerNo.trim(),
          RequestState: RequestState.RequestState.Delete,
          ReasonOfAdmin: "",
          Status: "",
        },
      ];
      this.$store
        .dispatch("OprationOnVacationArchive", { params })
        .then((result) => {
          //console.log(result);
          if (result.type === "success") {
            
            this.$emit("refresh");
            if (result.data && result.data.length > 0) {
              var description = result.data[0].Description;
              this.$refs.snackbar.show("success", description);
            }
          } else {
            this.$refs.snackbar.show("error", result.error);
          }
        });
    },
  },
};
</script>

<style>
</style>